const caching=Math.floor(Math.random() * 90000);
const ums_base_url='https://awsatapi.srpcdigital.com';
const drupal_base_url='https://aawsat.com';
/***UMS API List */
export const register = ums_base_url+'/api/ums/v1/register?'+caching;
export const profile = ums_base_url+'/api/ums/v1/profile?'+caching;
export const logout = ums_base_url+'/api/ums/v1/logout?'+caching;
export const loginvariable = ums_base_url+'/api/ums/v1/login?'+caching;
export const updateProfileUserImage = ums_base_url+'/api/ums/v1/updateProfileUserImage?'+caching;
export const updateUserDisplayName = ums_base_url+'/api/ums/v1/updateUserDisplayName?'+caching;
export const forgotPassword = ums_base_url+'/api/ums/v1/forgotPassword?'+caching;
export const loginCheckEmail = ums_base_url+'/api/ums/v1/loginCheckEmail?'+caching;
export const updateuserprofile = ums_base_url+'/api/ums/v1/update-user-profile?'+caching;
export const changePassword = ums_base_url+'/api/ums/v1/changePassword?'+caching;
export const addBookmarks = ums_base_url+'/api/ums/v1/addBookmarks?'+caching;
export const getBookmarks = ums_base_url+'/api/ums/v1/getBookmarksList?'+caching;
export const isLoggedIn = ums_base_url+'/api/ums/v1/isLoggedIn?'+caching;
export const removeBookmarks = ums_base_url+'/api/ums/v1/removeBookmarks?'+caching;
export const addFavoriteAuthor = ums_base_url+'/api/ums/v1/addFavoriteAuthor?'+caching;
export const getFavoriteAuthor = ums_base_url+'/api/ums/v1/getFavoriteAuthor?'+caching;
export const removeFavoriteAuthor = ums_base_url+'/api/ums/v1/removeFavoriteAuthor?'+caching;
export const addNewsletters = ums_base_url+'/api/ums/v1/addNewsletters?'+caching;
export const removeNewsletters = ums_base_url+'/api/ums/v1/removeNewsletters?'+caching;
export const addNotifications = ums_base_url+'/api/ums/v1/addNotifications?'+caching;
export const getMyNotifications = ums_base_url+'/api/ums/v1/getMyNotifications?'+caching;
export const removeNotifications = ums_base_url+'/api/ums/v1/removeNotifications?'+caching;
export const addFavoriteTopics = ums_base_url+'/api/ums/v1/addFavoriteTopics?'+caching;
export const getFavoriteTopics = ums_base_url+'/api/ums/v1/getFavoriteTopics?'+caching;
export const removeFavoriteTopics = ums_base_url+'/api/ums/v1/removeFavoriteTopics?'+caching;
export const getAPPNewslettersList = ums_base_url+'/api/ums/v1/getAPPNewslettersList?'+caching;
export const removeProfileUserImage = ums_base_url+'/api/ums/v1/removeProfileUserImage?'+caching;
export const getMyNewsletters = ums_base_url+'/api/ums/v1/getMyNewsletters?'+caching;

/***Ending of UMS API List */

/***Drupal API List */

/*** url with paramters**/
export const authorslist = drupal_base_url+'/api/authorslist/';
export const articlebytaxonomy = drupal_base_url + '/articlebytaxonomy/';
export const sectionlist = drupal_base_url +'/api/sectionlist/';
export const opinionapi = drupal_base_url +'/opinionapi/';


/***end url with parameters */


/*** url without paramters**/

export const sectionlist_all = drupal_base_url +'/api/v2/applist/sections?'+caching;
export const authorslist_all = drupal_base_url +'/api/v2/applist/authors?'+caching;

/***end url without parameters */





/***Ending Drupal API List */